var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeddingPartyChapterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.901489,
    y: 0.617188,
    width: 54.1558,
    height: 55.1587,
    rx: 7.25149,
    fill: "#C0D8D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24731 14.753C9.24731 13.595 10.1861 12.6562 11.3441 12.6562H47.2659C48.424 12.6562 49.3627 13.595 49.3627 14.753V38.6403C49.3627 39.7983 48.424 40.737 47.2659 40.737H11.3441C10.1861 40.737 9.24731 39.7983 9.24731 38.6402V14.753Z",
    fill: "url(#paint0_linear_1282_9091)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24731 14.753C9.24731 13.595 10.1861 12.6562 11.3441 12.6562H47.2659C48.424 12.6562 49.3627 13.595 49.3627 14.753V38.6403C49.3627 39.7983 48.424 40.737 47.2659 40.737H11.3441C10.1861 40.737 9.24731 39.7983 9.24731 38.6402V14.753Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7557 18.0732C42.7581 18.9817 42.3995 19.8539 41.7587 20.4976C41.118 21.1415 40.2476 21.5044 39.3391 21.5061C38.4305 21.5078 37.5589 21.1484 36.9155 20.5069C36.2723 19.8654 35.9104 18.9948 35.9094 18.0863C35.9087 17.1778 36.2688 16.3064 36.911 15.6637C37.553 15.0213 38.4242 14.6602 39.3327 14.6602C40.2387 14.6602 41.1079 15.0193 41.7496 15.659C42.3911 16.299 42.7529 17.167 42.7557 18.0733V18.0732Z",
    fill: "url(#paint1_linear_1282_9091)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1496 23.3744L41.8806 38.5669C41.7939 38.9601 41.4474 39.2415 41.0448 39.2456H37.671C37.2684 39.2414 36.9218 38.9601 36.8348 38.5669L32.5167 23.3744C32.4614 23.1252 32.5229 22.8644 32.6839 22.6663C32.8477 22.4655 33.0937 22.3496 33.3528 22.3516H45.3133C45.5725 22.3496 45.8185 22.4655 45.9822 22.6663C46.1433 22.8644 46.205 23.1252 46.1496 23.3744Z",
    fill: "url(#paint2_linear_1282_9091)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4642 19.7593C24.4642 20.7518 24.0941 21.7036 23.4355 22.4049C22.7769 23.1063 21.8839 23.5001 20.953 23.499C20.0223 23.4981 19.1298 23.1025 18.4725 22.3998C17.8154 21.6971 17.4471 20.7445 17.4489 19.752C17.4506 18.7598 17.8222 17.8087 18.4821 17.1084C19.142 16.4084 20.0357 16.0166 20.9667 16.0195C21.8951 16.0222 22.7848 16.4176 23.4404 17.1187C24.0959 17.8197 24.4642 18.7691 24.4642 19.7593H24.4642Z",
    fill: "url(#paint3_linear_1282_9091)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4642 19.7593C24.4642 20.7518 24.0941 21.7036 23.4355 22.4049C22.7769 23.1063 21.8839 23.5001 20.953 23.499C20.0223 23.4981 19.1298 23.1025 18.4725 22.3998C17.8154 21.6971 17.4471 20.7445 17.4489 19.752C17.4506 18.7598 17.8222 17.8087 18.4821 17.1084C19.142 16.4084 20.0357 16.0166 20.9667 16.0195C21.8951 16.0222 22.7848 16.4176 23.4404 17.1187C24.0959 17.8197 24.4642 18.7691 24.4642 19.7593H24.4642Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.305 38.1685C29.305 38.6366 28.923 39.0159 28.4517 39.0159H13.1095C12.638 39.0159 12.256 38.6366 12.256 38.1685C17.9075 29.0905 16.8721 31.3356 18.6475 30.3814L16.5624 25.0926C16.47 24.836 16.5144 24.5504 16.6801 24.3329C16.8353 24.1079 17.092 23.9731 17.3667 23.9727H24.2334C24.5108 23.9731 24.7705 24.1077 24.9298 24.3329C25.0907 24.5523 25.1345 24.8355 25.0476 25.0926L22.5516 30.3397C24.2685 31.2942 24.2334 29.4365 29.305 38.1685Z",
    fill: "url(#paint4_linear_1282_9091)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.305 38.1685C29.305 38.6366 28.923 39.0159 28.4517 39.0159H13.1095C12.638 39.0159 12.256 38.6366 12.256 38.1685C17.9075 29.0905 16.8721 31.3356 18.6475 30.3814L16.5624 25.0926C16.47 24.836 16.5144 24.5504 16.6801 24.3329C16.8353 24.1079 17.092 23.9731 17.3667 23.9727H24.2334C24.5108 23.9731 24.7705 24.1077 24.9298 24.3329C25.0907 24.5523 25.1345 24.8355 25.0476 25.0926L22.5516 30.3397C24.2685 31.2942 24.2334 29.4365 29.305 38.1685Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1282_9091",
    x1: 17.4893,
    y1: 12.6563,
    x2: 40.6808,
    y2: 49.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1282_9091",
    x1: 39.3326,
    y1: 14.6602,
    x2: 43.6673,
    y2: 17.8069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96CEC5",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1282_9091",
    x1: 39.3332,
    y1: 22.3516,
    x2: 49.1603,
    y2: 28.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96CEC5",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1282_9091",
    x1: 18.8902,
    y1: 16.0195,
    x2: 25.7548,
    y2: 23.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEEE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1282_9091",
    x1: 15.7588,
    y1: 23.9727,
    x2: 29.1974,
    y2: 41.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEEE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingPartyChapterIcon);
export default __webpack_public_path__ + "static/media/weddingPartyChapterIcon.c2576d7f1ac03141b593f831d59dea84.svg";
export { ForwardRef as ReactComponent };